export default __webpack_public_path__ + "static/media/rfactorIcon.8f35bec3.png";